import { tv } from '@change/ds-utils';

export const actionButton = tv({
	base: 'rounded-medium px-4 py-2',
	compoundVariants: [
		{
			// Classes to simulate the primary button from legacy DS
			class:
				'text-typography-inverse-strong! bg-[#E01A2B]! before:border-none! hover:bg-[#B71523]! before:hover:border-2! before:hover:border-solid! before:hover:border-black! active:bg-[#B71523]! before:active:border-2! before:active:border-solid! before:active:border-black!',
			actionType: 'shareExperimental',
		},
		{
			class: '*:text-size-body-small h-9 min-w-[104px] *:font-bold',
			variant: 'default',
		},
		{
			class: '*:text-size-body-bold h-12 min-w-20 py-3 pr-4 pl-3',
			variant: 'inline',
		},
		{
			class: '*:text-size-body-xs h-14 flex-1 flex-col gap-0.5 *:leading-4',
			variant: 'square',
		},
	],
	variants: {
		variant: {
			default: '',
			inline: '',
			square: '',
		},
		actionType: {
			edit: '',
			link: '',
			view: '',
			share: '',
			shareExperimental: '',
		},
	},
});
